import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import Tool from './tool';
import { pluck, pluckNumber } from '../../lib';
import MenuItemContainer from './menu-item-container';

var HamBurger =
/*#__PURE__*/
function (_Tool) {
  _inherits(HamBurger, _Tool);

  function HamBurger() {
    _classCallCheck(this, HamBurger);

    return _possibleConstructorReturn(this, _getPrototypeOf(HamBurger).apply(this, arguments));
  }

  _createClass(HamBurger, [{
    key: "configureAttributes",
    value: function configureAttributes() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _get(_getPrototypeOf(HamBurger.prototype), "configureAttributes", this).call(this, a);

      var b = this,
          c = b.config,
          d = b.getFromEnv('dataSource').chart;
      c.baseFontFamily = pluck(a.baseFontFamily, d.basefont, 'Verdana,sans'), c.baseFontSize = pluckNumber(a.baseFontSize, d.basefontsize, 10), c.baseFontColor = pluck(a.baseFontColor, d.basefontcolor, '595959'), c.skipGraphics = !0, b.createListContainer();
    }
  }, {
    key: "createListContainer",
    value: function createListContainer() {
      var a,
          b = this;
      a = b.attachChild(MenuItemContainer, 'listContainer', 'listContainer'), a.configure();
    }
  }, {
    key: "appendInMenu",
    value: function appendInMenu() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var b,
          c,
          d = this,
          e = d.getChild('listContainer');

      for (c = a.length, b = 0; b < c; b++) {
        e.addItem(a[b]);
      }

      d.config.skipGraphics = !1;
    }
  }]);

  return HamBurger;
}(Tool);

export default HamBurger;